import React from "react";

function StudioIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <defs>
        <path id="path-1" d="M0 0L10.9879518 0 10.9879518 16 0 16z"></path>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(3)">
          <mask id="mask-2" fill="#fff">
            <use xlinkHref="#path-1"></use>
          </mask>
          <path
            fill="#FFF"
            d="M10.239 6c-.415 0-.75.334-.75.722V8a4.001 4.001 0 01-4.254 3.99c-2.063-.13-3.737-2.08-3.737-4.15V6.723C1.498 6.334 1.163 6 .75 6 .336 6 0 6.334 0 6.722v1.005c0 2.801 1.997 5.3 4.745 5.678V14.5H3.496a1 1 0 00-.998 1.049c.013.257.243.451.499.451H7.99c.257 0 .486-.194.498-.451a1 1 0 00-.997-1.049H6.243v-1.055A5.503 5.503 0 0010.988 8V6.722c0-.388-.334-.722-.75-.722m-4.744 5a2.998 2.998 0 002.997-3H5.993a.501.501 0 010-1h2.498V6H5.993a.501.501 0 010-1h2.498V3.972H5.993a.5.5 0 010-1L8.491 3a2.998 2.998 0 10-5.993 0v5c0 1.656 1.313 3 2.996 3"
            mask="url(#mask-2)"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default React.memo(StudioIcon);
